/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export class SharedViewKey {
  static readonly LETTER_HEADER = 'shared/view/letter-header';
  static readonly QUESTION_DIALOG = 'shared/view/question-dialog';
  static readonly USER = 'shared/view/user';
  static readonly USER_SIDEBAR = 'shared/view/user-sidebar';
  static readonly SUBSCRIPTION = 'shared/view/subscription';
}
